import { CloudFile } from 'owa-attachment-file-types';
import { createSharingLinkView } from 'owa-compose-link';
import { checkSharingLinkUrlDomain, createGetSharingInfoResponse } from 'owa-fileprovider-link';
import {
    createSharingLinkFromFileProvider,
    CreateSharingLinkFromFileProviderResult,
} from 'owa-fileprovider-link-services';
import { getGuid } from 'owa-guid';
import { AnchorElementsSource, getSharingLinkInfo, SharingLinkInfo } from 'owa-link-data';
import { GetSharingInfoResponseBase } from 'owa-fileprovider-link-services';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import { trace } from 'owa-trace';
import { onSharingLinkDetected } from '../actions/internalActions';
import LinkPlugin from '../plugin/LinkPlugin';
import { LinkIdContainer } from '../schema/LinkIdContainer';
import { LinkPluginViewStore } from '../store/schema/LinkPluginViewStore';
import { getStore } from '../store/store';
import { OUTLOOK_BEAUTIFIED_PREFIX } from '../utils/constants';

export async function insertLinkIntoEditor(
    file: CloudFile,
    insertLinksTaskId: string,
    linkPlugin: LinkPlugin,
    linkIdContainer: LinkIdContainer
): Promise<boolean> {
    trace.info(`insertLinkIntoEditor:${linkPlugin.editor === null}`);

    try {
        if (isNullOrWhiteSpace(file.name)) {
            throw new Error('InsertLink should pick up a file with a valid name');
        }

        const linkId = OUTLOOK_BEAUTIFIED_PREFIX + getGuid();
        const createLinkResult: CreateSharingLinkFromFileProviderResult = await createSharingLinkFromFileProvider(
            file.providerType,
            file.fileId,
            file.location
        );

        checkSharingLinkUrlDomain(createLinkResult.link.webUrl, file.providerType);

        // Check whether this batch has been aborted
        const linkPluginViewStore: LinkPluginViewStore = getStore();
        if (insertLinksTaskId !== linkPluginViewStore.insertLinksTaskId) {
            trace.info('insertLinkIntoEditor: aborted');
            return false;
        }

        trace.info('insertLinkIntoEditor: createGetSharingInfoResponse');
        const sharingInfo: GetSharingInfoResponseBase = createGetSharingInfoResponse(
            file,
            createLinkResult,
            linkId
        );

        // Raise onSharingLinkDetected to addSharingLink, checkforLinkToken and addComposeLinkViewState
        // VSTO 57638: 1. rename the action
        // 2. we may also trigger checkPerm on this event for ODB links only.
        // 3. Will only call lazyPrefetchWacResourcesForFiles for ODB links.
        // 4. checkforLinkToken only for ODB links
        onSharingLinkDetected(
            linkId,
            createLinkResult.link.webUrl,
            linkIdContainer.sharingLinkIds,
            sharingInfo,
            true /* shouldAddComposeLinkViewState */,
            false /* isPreviouslyBeautified */,
            AnchorElementsSource.InsertLinkFromAttachMenu,
            file.providerType
        );

        const sharingLink: SharingLinkInfo = getSharingLinkInfo(linkId);

        // Insert the beautiful ink into editor
        trace.info('insertLinkIntoEditor: createSharingLinkView');
        createSharingLinkView(
            linkPlugin.editor,
            linkPlugin.getRecipientWells,
            linkPlugin.fromAddress,
            linkIdContainer.composeId,
            null /* The original anchorElement */,
            sharingLink,
            true /* sharingLinkInfoHasValidFileName */,
            sharingLink.mimeType,
            true /* shouldBeautify*/,
            false /* isLinkPreviouslyBeautified */,
            true /* insertFromFilePicker */
        );
    } catch (e) {
        // VSTO 57638: Display error in info bar
        trace.error(e.message);
    }
    return true;
}
